import { render, staticRenderFns } from "./ModalVisualizacaoLaudo.vue?vue&type=template&id=723b73e5&lang=pug"
import script from "./ModalVisualizacaoLaudo.vue?vue&type=script&lang=js"
export * from "./ModalVisualizacaoLaudo.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizacaoLaudo.vue?vue&type=style&index=0&id=723b73e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports